import React from "react";

import '../Style.css';

import { IoIosSend } from "react-icons/io";
import { IoCall } from "react-icons/io5";
import { BiRightTopArrowCircle } from "react-icons/bi";

import Economic_Jewellery_Scale_2 from '../Assets/Images/Economic Scales/Jewellery Scale/Economic_Jewellery_Scale_2.png'



function Jewelleryscale() {
    return (
        <div>


            <section className="py-5">
                <div className="container py-lg-5">
                    <div class="mt-3">
                        <p class="section-top-heading-css py-3 py-lg-0">Jewellery Scale</p>

                    </div>
                    <div className="row   row-cols-lg-2 row-cols-1 min-vh-100 justify-content-center g-4 align-items-center ">

                        <div className="col text-center">
                            <div className="about-small-card-css card h-100 p-4">
                                <div className="text-center image-stretch-css">
                                    <img className="product-swiper-image" src={Economic_Jewellery_Scale_2} />
                                </div>
                                <p className="about-card-heading-css text-center">

                                </p>
                                <p className="about-card-para-css">Capacity : </p>
                                <p className="about-card-para-css">Accuracy : </p>
                                <p className="about-card-para-css">Platter Size ( mm ) : </p>
                                <div className="row row-cols-lg-3 row-cols-2 justify-content-center g-3 text-center">
                                    <div className="col">
                                        <a href="https://wa.me/919443030062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Get Price <IoIosSend className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a href="tel:+91 94430 30062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2 ">Call Now <IoCall className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a href="/" className="" >
                                            <button className="btn CTA-button-css-2">
                                                <span className="underline_text ">Know More</span> <BiRightTopArrowCircle className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>


                </div>
            </section>


        </div >

    );
}

export default Jewelleryscale;
